import React from 'react';
import PropTypes from 'prop-types';
import Head from 'next/head';
import styled from 'styled-components';

import { Layout, Box, useMedia } from './Boneyard';

import WrappedSiteFooter from './siteLayout/WrappedSiteFooter';
import SiteHeader from './siteLayout/SiteHeader';
import IsStadium from '../utils/isStadium';
import META_TAGS_QUERY from './siteLayout/frontpageMetaTags.query.graphql.js';
import { useSSRQuery } from '../graphql';
import Markdown from './Markdown';
import SiteHeaderResetPassword from './siteLayout/SiteHeaderResetpassword';
import { withApplicationQuery } from '../graphql/components/ApplicationQueryProvider';
import SITE_LAYOUT_TRANSLATIONS from './siteLayout/siteLayoutTranslations.query.graphql.js';
import { useUserContext } from '@g4/next-furniture/UserContextProvider';

const SiteLayout = ({ title, children, ...props }) => {
  const { data } = useSSRQuery(META_TAGS_QUERY);
  const {
    isTravelAgent,
    agentType,
  } = useUserContext();
  const hasAgentBanner = !!agentType && !isTravelAgent;
  const mq = useMedia();

  const StyledBox = styled(Box)`
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    ${props.backgroundColor && 'background-color:props.backgroundColor'}
  `;

  return (
    <Layout>
      <Head>
        <title>{title}</title>
      </Head>
      {title === 'Password-form' ? (
        <SiteHeaderResetPassword pageContext={title} />
      ) : (
        <>
          {data && (
            <Markdown source={data?.application.frontPageMetatagsContent} />
          )}
          <SiteHeader pageContext={title} {...props} />
        </>
      )}
      <StyledBox backgroundColor={props.backgroundColor}>
        <Layout.Main>
          <Layout.Content>
            {/* TODO: find a better solution to remove white space below header */}
            <div id="main" style={{ paddingTop: (mq && mq.gte('md') && hasAgentBanner) ? 32 : 1 }}>
              {children}
            </div>
          </Layout.Content>
        </Layout.Main>
      </StyledBox>

      <WrappedSiteFooter isStadium={IsStadium()} />
    </Layout>
  );
};

SiteLayout.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.element.isRequired,
  backgroundColor: PropTypes.string,
};

export default withApplicationQuery(SITE_LAYOUT_TRANSLATIONS, SiteLayout);
